import { DateInput, DateInputProps } from '@mantine/dates';

interface DateInputWrapperProps
  extends Omit<DateInputProps, 'valueFormat' | 'dateParser'> {
  valueFormat?: string;
}

export function DateInputWrapper({
  valueFormat = 'DD/MM/YYYY',
  onChange,
  ...props
}: DateInputWrapperProps): JSX.Element {
  const dateParser = (input: string) => {
    const parts = input.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        // Create date at noon to avoid timezone issues when serializing
        return new Date(year, month, day, 12, 0, 0, 0);
      }
    }

    return new Date(input);
  };

  const handleChange = (date: Date | null) => {
    if (date && onChange) {
      // Ensure any date has time set to noon to avoid timezone issues
      const dateAtNoon = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        12,
        0,
        0,
        0
      );
      onChange(dateAtNoon);
    } else if (onChange) {
      onChange(date);
    }
  };
  return (
    <DateInput
      valueFormat={valueFormat}
      dateParser={dateParser}
      onChange={handleChange}
      placeholder="DD/MM/YYYY"
      {...props}
    />
  );
}
